import React from 'react';
import { Button } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './PinyinToolbar.less';

export const PinyinToolbar = (props) => {
  const { onEditPinyin } = props;

  return (
    <div className={classNames('rdw-image-wrapper', styles.pinyinWrapper)}>
      <Button onClick={onEditPinyin}>Edit Pinyin</Button>
    </div>
  );
};

PinyinToolbar.propTypes = {
  onEditPinyin: PropTypes.func.isRequired,
};
